

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _index = require('xo-models/src/fi/index');

require('xo-page-components/src/aside-header/directive');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/popup/directive');

require('../bank-input/directive');

var _util = require('../../fi-contingency-list/util');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddBank', function () {
    return {
        template: _template2['default'],
        scope: {
            parentCallbacks: '=?',
            errorMessage: '=?',
            bank: '=?',
            sidebar: '=?',
            hideparenthead: '=?',
            message: '=?',
            pageLevel: '=?',
            showSetPreferredFi: '=?',
            showCancel: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.model = $scope.bank || new _index.$AddBankModel({
                id: 123
            });
            $scope.locale = _squid.$locale;
            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = false;
            }
            $scope.onSubmit = function () {
                if ($scope.pageLevel) {
                    $scope.pageLevel.message = null;
                }

                var data = $scope.model.getBankData();

                function mapValidationErrors(err) {
                    var fields = err && err.fields || [];

                    fields.forEach(function (fieldError) {
                        if (fieldError && fieldError.property) {
                            fieldError.field = fieldError.property;
                        }
                    });
                    return {
                        fields: fields
                    };
                }

                return $scope.model.action('validate', {
                    data: data,
                    resultModel: {},
                    success: function success(successData) {
                        $scope.model.creditorDetails = successData.creditorDetails;
                        $scope.model.fiDetails = successData.fiDetails;
                        $scope.parentCallbacks.addBankDone($scope.model);
                        if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                            $scope.parentCallbacks.setBankPrefer(true);
                        }
                    },
                    contingencies: {
                        VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
                            $scope.errorMessage = _util.$fiErrorUtil.addPageErrors(contingencyData, 'bank');
                            _util.$fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
                        }
                    },
                    validation: function validation(res) {
                        return _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
                    }
                });
            };

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _index.$BillingAddressesModel.instance()
            }).then(function () {
                $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];
                $scope.model.user.first_name = $scope.auth.first_name;
                $scope.model.user.last_name = $scope.auth.last_name;
                $scope.model.user.country = $scope.model.address && $scope.model.address.country;
            });
        }]
    };
});

_squid.$locale;

_squid.$populate;

_auth.$AuthModel;

_index.$AddBankModel;

_index.$BillingAddressesModel;

_util.$fiErrorUtil;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/addbank/directive.js
// module chunks = 0